module.exports = __webpack_public_path__ + "img/migrate.9214b73.svg";